import { flushSync } from "react-dom";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { loadDashboardWithSearch } from "views/logic/views/Actions";
import { setIsDirty, setIsNew } from "views/logic/slices/viewSlice";
import { createView } from "views/api/views";
export default (view, history, entityShare, existingViewId, search) => async (dispatch) => {
  try {
    const savedView = await createView(view, entityShare, existingViewId);
    flushSync(() => {
      dispatch(setIsDirty(false));
      dispatch(setIsNew(false));
    });
    loadDashboardWithSearch(history, savedView.id, search);
    UserNotification.success(
      i18n.t("actions_menu.save_success", { ns: "search", title: view.title }),
      i18n.t("save_view_notifications.success_title", { ns: "search" })
    );
  } catch (error) {
    UserNotification.error(
      i18n.t("actions_menu.save_error", { ns: "search", error }),
      i18n.t("save_view_notifications.error_title", { ns: "search" })
    );
  }
};
